export default __webpack_public_path__ + "static/media/visionIcon.6443cb46.svg";